export default {
  SET_CREDIT_REQUESTS: (state, creditRequests) => {
    state.creditRequests = creditRequests;
  },
  SET_CREDIT_REPORTS: (state, creditReports) => {
    state.creditReports = creditReports;
  },
  SET_TOTAL_CREDIT_REQUESTS: (state, total) => {
    state.total = total;
  },
  SET_TOTAL_CREDIT_REPORTS: (state, total) => {
    state.total = total;
  },
  SET_SELECTED: (state, payload) => {
    state.selected = payload;
  },
};
